var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "limited-width-lg" }, [
    _c("div", { staticClass: "container my-2" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c("accordion-component", {
              attrs: {
                content: [
                  {
                    title: "login.loginPageBottomTitle",
                    content: "login.loginPageBottomText"
                  }
                ],
                prefix: "whyRegister"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt-4" },
          [
            _c("div", { staticClass: "col-md-12" }, [
              _c("h2", { staticClass: "text-center mb-4" }, [
                _vm._v(_vm._s(_vm.translate.login.dontHaveAccount))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-12 mb-4" }, [
              _c("div", { staticClass: "limited-width-sm px-3" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-secondary btn-block",
                    attrs: {
                      href: _vm.regionRelativeUrl("/users/registration/")
                    }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.translate.login.register) +
                        "\n                        "
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("registration-features-component")
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b78b45b8", { render: render, staticRenderFns: staticRenderFns })
  }
}